import { useEffect, useRef } from 'react';

export function useResizeObserver({
	documentRef,
	listRef,
	pdfFile,
	computePageWidth,
	setResizedContainerHeight,
}: {
	documentRef?: React.RefObject<HTMLElement>;
	listRef?: React.RefObject<any>;
	pdfFile: any;
	computePageWidth: (width: number) => void;
	setResizedContainerHeight: (height: number) => void;
}) {
	const heightDifferenceBeforeResize = useRef(0);

	useEffect(() => {
		const documentRefValue = documentRef?.current;

		const resizeObserver = new ResizeObserver((entry: ResizeObserverEntry[]) => {
			if (listRef.current) {
				(listRef.current as any).resetAfterIndex(0);
			}
			const { width: widthAfterResize, height: heightAfterResize } = entry[0].contentRect;
			computePageWidth(widthAfterResize);

			if (pdfFile) {
				if (heightDifferenceBeforeResize.current === 0) {
					heightDifferenceBeforeResize.current = Math.abs(
						heightAfterResize - (documentRef.current?.clientHeight ?? 0)
					);
				}
				const newResizedContainerHeight = Math.abs(
					heightAfterResize - heightDifferenceBeforeResize.current
				);
				setResizedContainerHeight(newResizedContainerHeight);
			}
		});

		if (documentRefValue) {
			resizeObserver.observe(documentRefValue);
		}

		return () => {
			if (documentRefValue) {
				resizeObserver.unobserve(documentRefValue);
			}
		};
	}, [pdfFile, documentRef, listRef, computePageWidth, setResizedContainerHeight]);
}
